import React, { PureComponent, Fragment } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import { Link } from "react-scroll";
import { BrowserRouter as Router, Link as Link1 } from "react-router-dom";
import Logo from "./../../assets/Marquis_Galleria_Logo-01.svg";
class Header extends PureComponent {

  // constructor(props) {
  //     super(props);
  //     this.state = {
  //         addClass: false,
  //         navclassName: "",
  //     }
  // }

  // componentDidMount() {
  //     window.addEventListener("scroll", this.handleScroll);
  // }

  // handleScroll = () => {
  //     if (window.pageYOffset > 300) {
  //         if (!this.state.navclassName) {
  //             this.setState({ navclassName: "navactive" });
  //         }
  //     } else {
  //         if (this.state.navclassName) {
  //             this.setState({ navclassName: "" });
  //         }
  //     }

  // }

  updateURLParameter(url, param, paramVal) {
    var newAdditionalURL = "";
    var tempArray = url.split("?");
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = "";
    if (additionalURL) {
      tempArray = additionalURL.split("&");
      for (var i = 0; i < tempArray.length; i++) {
        if (tempArray[i].split("=")[0] != param) {
          newAdditionalURL += temp + tempArray[i];
          temp = "&";
        }
      }
    }

    var rows_txt = temp + "" + param + "=" + paramVal;
    return baseURL + "?" + newAdditionalURL + rows_txt;
  }

  gotoSection() {
    document.getElementById("basic-navbar-nav123").click();

    setTimeout(function () {
      let url = window.location.toString();

      let dataxx = url.split("#");
      document
        .getElementById("" + dataxx[1])
        .scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  }

  addhashtourlforcontactbuttonclicked() {
    window.history.pushState(
      "header-contact-button-clicked",
      "Title",
      "/marquis-signature-cpc-dubai/?mail=header-contact-button-clicked"
    );
  }

  render() {
    return (
      <Fragment>
        {/* Header Start */}
        {/* <Navbar fixed="top" bg="light" expand="lg" className={`marquis-navbar ${this.state.navclassName}`}> */}
        <Navbar fixed="top" bg="light" expand="lg" className="marquis-navbar">
          <Container className="marquis-navBG">
            <Navbar.Brand>
              <a href="/marquis-galleria-cpc-dubai">
                <img
                  src={Logo}
                  className="img-fluid bgLogo"
                  alt="Marquis-logo"
                />
              </a>
            </Navbar.Brand>

            {/* <Navbar.Toggle aria-controls="basic-navbar-nav" id="basic-navbar-nav123" /> */}

            {/* <Navbar.Collapse
              className="justify-content-end"
              id="basic-navbar-nav"
            >
              <Nav.Item>
                <Link1
                  onClick={this.gotoSection} 
                  to="/#homefeatures-sec"                  
                  className="nav-link"
                >
                  {" "}
                  Features{" "}
                </Link1>
              </Nav.Item>
              <Nav.Item>
                <Link1
                  onClick={this.gotoSection} 
                  to="/#homeamenities-sec"                 
                  className="nav-link"
                >
                  Amenities{" "}
                </Link1>
              </Nav.Item>
              <Nav.Item>
                <Link1
                  onClick={this.gotoSection} 
                  to="/#homehighlights-sec"                  
                  className="nav-link"
                >
                  Highlights{" "}
                </Link1>
              </Nav.Item>
              <Nav.Item>
                <Link1
                  onClick={this.gotoSection} 
                  to="/#homefloorplan-sec"                 
                  className="nav-link"
                >
                  Floor Plan{" "}
                </Link1>
              </Nav.Item>
              <Nav.Item>
                <Link1
                  onClick={this.gotoSection} 
                  to="/#homelocation-sec"                 
                  className="nav-link"
                >
                  Location{" "}
                </Link1>
              </Nav.Item>
              <Nav.Item>
                <Link1
                  onClick={this.gotoSection} 
                  to="/#homecontactus-sec"                  
                  className="nav-link"
                >
                  Contact Us{" "}
                </Link1>
              </Nav.Item>
              <Nav.Item>
                <Link1
                  onClick={this.gotoSection} 
                  to="/#becomeAgent"                 
                  className="nav-link goldernColorBtn"
                //   onClick={this.addhashtourlforcontactbuttonclicked}
                >
                  Become an Agent{" "}
                </Link1>
              </Nav.Item>
            </Navbar.Collapse> */}
          </Container>
        </Navbar>
      </Fragment>
    );
  }
}

export default Header;
